export default "__VITE_ASSET__D06Su79J__"